export const pricingI18NPl = {
    hourlyRateFormat: (rate: number, currency: string) =>
        `${currency} ${rate}/h`,
    monthlyRateFormat: (rate: number, currency: string) =>
        `${currency} ${rate}/mc`,
    noValuePlaceholder: "-",
};
